// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="694.029 -5213.595 9.971 9.189"><path d="M704-5209.312v.625h-8.779l3.842 3.842-.439.439-4.595-4.594 4.595-4.595.439.439-3.842 3.844z"/></svg>
);

export default fn;
